// extracted by mini-css-extract-plugin
module.exports = {"chevronGroup":"HorizontalItemScroller_chevronGroup__S2BWM","chevronCircle":"HorizontalItemScroller_chevronCircle__nPhWH"};